import { EnvironmentProviders, Provider } from '@angular/core';
import { abiosConfigName } from '@bcf-v2-configurators/tokens/abios/lvbet/abios-config-name';
import { ABIOS_CONFIG_NAME } from '@bcf-v2-configurators/tokens/abios/token';
import {
  campaignIdsWithExpirationDate,
  superiorIdsWithExpirationDate
} from '@bcf-v2-configurators/tokens/affiliate/lvbetcom/affiliate-ids-with-expiration-date';
import {
  CAMPAIGN_IDS_WITH_EXPIRATION_DATE,
  SUPERIOR_IDS_WITH_EXPIRATION_DATE
} from '@bcf-v2-configurators/tokens/affiliate/token';
import { appMobileSportsCountryBlocker } from '@bcf-v2-configurators/tokens/app-country-blocker/lvbetcom/app-country-blocker';
import { APP_COUNTRY_BLOCKER } from '@bcf-v2-configurators/tokens/app-country-blocker/token';
import { betOnActionFreeModeEnabled } from '@bcf-v2-configurators/tokens/bet-on-action/lvbetcom/bet-on-action-free-mode-enabled';
import { BET_ON_ACTION_FREE_MODE_ENABLED } from '@bcf-v2-configurators/tokens/bet-on-action/token';
import { payoutDetailsEnabled } from '@bcf-v2-configurators/tokens/betslip/lvbetcom/payout-details-enabled';
import { PAYOUT_DETAILS_ENABLED } from '@bcf-v2-configurators/tokens/betslip/token';
import { casinoLink, liveCasinoLink } from '@bcf-v2-configurators/tokens/casino-links/lvbetcom/casino-links';
import { CASINO_FULL_URL, LIVE_CASINO_FULL_URL } from '@bcf-v2-configurators/tokens/casino-links/token';
import { gamesImagesAssetsUrl } from '@bcf-v2-configurators/tokens/casino/lvbetcom/games-images-assets-url';
import { GAMES_IMAGES_ASSETS_URL } from '@bcf-v2-configurators/tokens/casino/token';
import { I18N_DESC_LOADER } from '@bcf-v2-configurators/tokens/descs/token';
import { editProfileAddressAvailableFieldsFn } from '@bcf-v2-configurators/tokens/edit-profile/lvbetcom/edit-profile-available-fields';
import { editProfileShowBankAccountInfo } from '@bcf-v2-configurators/tokens/edit-profile/lvbetcom/edit-profile-show-bank-account-info';
import {
  EDIT_PROFILE_ADDRESS_AVAILABLE_FIELDS,
  EDIT_PROFILE_SHOW_BANK_ACCOUNT_INFO
} from '@bcf-v2-configurators/tokens/edit-profile/token';
import { footerBrandName } from '@bcf-v2-configurators/tokens/footer/lvbetcom/footer-brand-name';
import { footerLinksFn } from '@bcf-v2-configurators/tokens/footer/lvbetcom/footer-links';
import { spSidebarLinksFn } from '@bcf-v2-configurators/tokens/footer/lvbetcom/sp-sidebar-links';
import { FOOTER_BRAND_NAME, FOOTER_LINKS, SP_SIDEBAR_LINKS } from '@bcf-v2-configurators/tokens/footer/token';
import { imgWebConfig } from '@bcf-v2-configurators/tokens/img-webp/lvbetcom/img-web-config';
import { IMG_WEB_CONFIG } from '@bcf-v2-configurators/tokens/img-webp/token';
import { introHasCasinoComponents } from '@bcf-v2-configurators/tokens/intro/lvbetcom/intro-has-casino-components';
import { INTRO_HAS_CASINO_COMPONENTS } from '@bcf-v2-configurators/tokens/intro/token';
import { IPQS_REGISTER_IP_CHECK_ENABLED } from '@bcf-v2-configurators/tokens/ipqs/token';
import { ladeskChatAdditionalConfig } from '@bcf-v2-configurators/tokens/ladesk-chat/lvbetcom/ladesk-chat-additional-config';
import { LADESK_CHAT_ADDITIONAL_CONFIG } from '@bcf-v2-configurators/tokens/ladesk-chat/token';
import { lvbetcomLanguageSwitcherFlagMap } from '@bcf-v2-configurators/tokens/language-switcher/lvbetcom/lvbetcom-language-switcher-flag-map';
import { LANGUAGE_SWITCHER_FLAG_MAP } from '@bcf-v2-configurators/tokens/language-switcher/token';
import { lotteryBrandName } from '@bcf-v2-configurators/tokens/lottery/lvbet/lottery-brand-name';
import { LOTTERY_BRAND_NAME } from '@bcf-v2-configurators/tokens/lottery/token';
import { lvWheelConfig } from '@bcf-v2-configurators/tokens/lv-wheel/lvbetcom/lv-wheel-config';
import { lotteryAssetsUrlValue } from '@bcf-v2-configurators/tokens/lv-wheel/lvbetpl/lottery-assets-url';
import { LV_WHEEL_CONFIG } from '@bcf-v2-configurators/tokens/lv-wheel/token';
import { lvisionBetBoosterApiKeys } from '@bcf-v2-configurators/tokens/lvision-bet-booster/lvbetcom/lvision-bet-booster-api-keys';
import { LVISION_BET_BOOSTER_API_KEYS } from '@bcf-v2-configurators/tokens/lvision-bet-booster/token';
import { modalCookiesShowIndicator } from '@bcf-v2-configurators/tokens/modals/lvbetcom/modal-cookies-show-indicator';
import { modalNewTermsAlternativeTitle } from '@bcf-v2-configurators/tokens/modals/lvbetcom/modal-new-terms-alternative-title';
import { modalNewTermsShowVersionLink } from '@bcf-v2-configurators/tokens/modals/lvbetcom/modal-new-terms-show-version-link';
import { modalWithdrawStatusMessage } from '@bcf-v2-configurators/tokens/modals/lvbetcom/modal-withdraw-status-message';
import {
  MODAL_COOKIES_INDICATOR,
  MODAL_NEW_TERMS_ALTERNATIVE_TITLE,
  MODAL_NEW_TERMS_SHOW_VERSION_LINK,
  SHOW_MODAL_WITHDRAW_STATUS_MESSAGE
} from '@bcf-v2-configurators/tokens/modals/token';
import { COMMISSION_ENABLED } from '@bcf-v2-configurators/tokens/my-bets/token';
import { OPTIMOVE_SDK_CONFIG_LOADER } from '@bcf-v2-configurators/tokens/optimove-sdk/tokens';
import { piqStyles } from '@bcf-v2-configurators/tokens/piq-styles/lvbetcom/piq-styles';
import { piqTheme } from '@bcf-v2-configurators/tokens/piq-styles/lvbetcom/piq-theme';
import { PIQ_CSS, PIQ_THEME } from '@bcf-v2-configurators/tokens/piq-styles/token';
import { REGISTER_ENABLED } from '@bcf-v2-configurators/tokens/register/token';
import { RG_LIMITS_PARALLEL_TIME_VALUES_API_KIND } from '@bcf-v2-configurators/tokens/rg-limits-parallel/token';
import { sportsImagesAssetsUrl } from '@bcf-v2-configurators/tokens/sports/lvbetcom/sports-images-assets-url';
import { SPORTS_IMAGES_ASSETS_URL } from '@bcf-v2-configurators/tokens/sports/token';
import { statscoreVizuConfig } from '@bcf-v2-configurators/tokens/statscore-vizu-config/lvbet/statscore-vizu-config';
import { STATSCORE_VIZU_CONFIG } from '@bcf-v2-configurators/tokens/statscore-vizu-config/token';
import { provideVanillaTsTokens } from '@bcf-v2-shared/misc/vanilla-ts-providers/provide-vanilla-ts-tokens';
import { logRocketApiKey } from '@bcf-vanilla-ts-v1-configurators/tokens/log-rocket/lvbetcom/log-rocket-api-key';
import { registerLogRocketApiKey } from '@bcf-vanilla-ts-v1-configurators/tokens/log-rocket/token';
import { LOTTERY_ASSETS_URL } from '@bcf-vanilla-ts-v1-configurators/tokens/lottery/token';
import { rgLimitsParallelTimeValuesApiKind } from '@bcf-vanilla-ts-v1-configurators/tokens/rg-limits-parallel/lvbetcom/rg-limits-parallel-time-values-api-kind';

export const settingsProviders: (Provider | EnvironmentProviders)[] = [
  {
    provide: IMG_WEB_CONFIG,
    useValue: imgWebConfig
  },
  {
    provide: I18N_DESC_LOADER,
    useValue: () =>
      import(
        /* webpackChunkName: "const-i18n-desc" */ '@bcf-v2-configurators/tokens/descs/lvbetcom/mobile-web/i18n-desc'
        // eslint-disable-next-line @typescript-eslint/typedef
      ).then((mod) => mod.i18nDesc)
  },
  {
    provide: GAMES_IMAGES_ASSETS_URL,
    useValue: gamesImagesAssetsUrl
  },
  {
    provide: LANGUAGE_SWITCHER_FLAG_MAP,
    useValue: lvbetcomLanguageSwitcherFlagMap
  },
  {
    provide: EDIT_PROFILE_ADDRESS_AVAILABLE_FIELDS,
    useValue: editProfileAddressAvailableFieldsFn
  },
  {
    provide: EDIT_PROFILE_SHOW_BANK_ACCOUNT_INFO,
    useValue: editProfileShowBankAccountInfo
  },
  {
    provide: LADESK_CHAT_ADDITIONAL_CONFIG,
    useValue: ladeskChatAdditionalConfig
  },
  {
    provide: STATSCORE_VIZU_CONFIG,
    useValue: statscoreVizuConfig
  },
  {
    provide: ABIOS_CONFIG_NAME,
    useValue: abiosConfigName
  },
  {
    provide: CASINO_FULL_URL,
    useValue: casinoLink
  },
  {
    provide: LIVE_CASINO_FULL_URL,
    useValue: liveCasinoLink
  },
  {
    provide: FOOTER_LINKS,
    useValue: footerLinksFn
  },
  {
    provide: SP_SIDEBAR_LINKS,
    useValue: spSidebarLinksFn
  },
  {
    provide: FOOTER_BRAND_NAME,
    useValue: footerBrandName
  },
  {
    provide: IPQS_REGISTER_IP_CHECK_ENABLED,
    useValue: false
  },
  {
    provide: REGISTER_ENABLED,
    useValue: false
  },
  {
    provide: LVISION_BET_BOOSTER_API_KEYS,
    useValue: lvisionBetBoosterApiKeys
  },
  {
    provide: RG_LIMITS_PARALLEL_TIME_VALUES_API_KIND,
    useValue: rgLimitsParallelTimeValuesApiKind
  },
  {
    provide: OPTIMOVE_SDK_CONFIG_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/optimove-sdk/lvbetcom/sportsbook/mobile-web/optimove-sdk-config').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.optimoveSdkConfigs
      )
  },
  {
    provide: LV_WHEEL_CONFIG,
    useValue: lvWheelConfig
  },
  {
    provide: LOTTERY_ASSETS_URL,
    useValue: lotteryAssetsUrlValue
  },
  {
    provide: PAYOUT_DETAILS_ENABLED,
    useValue: payoutDetailsEnabled
  },
  {
    provide: MODAL_NEW_TERMS_SHOW_VERSION_LINK,
    useValue: modalNewTermsShowVersionLink
  },
  {
    provide: MODAL_NEW_TERMS_ALTERNATIVE_TITLE,
    useValue: modalNewTermsAlternativeTitle
  },
  {
    provide: MODAL_COOKIES_INDICATOR,
    useValue: modalCookiesShowIndicator
  },
  {
    provide: SHOW_MODAL_WITHDRAW_STATUS_MESSAGE,
    useValue: modalWithdrawStatusMessage
  },
  { provide: PIQ_THEME, useValue: piqTheme },
  { provide: PIQ_CSS, useValue: piqStyles },
  {
    provide: APP_COUNTRY_BLOCKER,
    useValue: appMobileSportsCountryBlocker
  },
  {
    provide: CAMPAIGN_IDS_WITH_EXPIRATION_DATE,
    useValue: campaignIdsWithExpirationDate
  },
  {
    provide: SUPERIOR_IDS_WITH_EXPIRATION_DATE,
    useValue: superiorIdsWithExpirationDate
  },
  provideVanillaTsTokens(() => {
    registerLogRocketApiKey(logRocketApiKey);
  }),
  {
    provide: LOTTERY_BRAND_NAME,
    useValue: lotteryBrandName
  },
  {
    provide: COMMISSION_ENABLED,
    useValue: false
  },
  {
    provide: INTRO_HAS_CASINO_COMPONENTS,
    useValue: introHasCasinoComponents
  },
  {
    provide: BET_ON_ACTION_FREE_MODE_ENABLED,
    useValue: betOnActionFreeModeEnabled
  },
  {
    provide: SPORTS_IMAGES_ASSETS_URL,
    useValue: sportsImagesAssetsUrl
  }
];
